import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Get data of specified service.
 * @param serviceId {string}
 * @returns {Promise<AxiosResponse<object>>}: service data.
 * @constructor
 */
const GetServiceInfo = async serviceId => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.SERVICE.replace(':id', serviceId)
)

/**
 *
 * Search for services.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = async listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.SERVICES,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

/**
 * Force-close an in-progress service (admin).
 * @param serviceId {string}
 * @param reason {string}
 * @returns {Promise<AxiosResponse<object>>}
 */
const ForceClose = async (serviceId, reason) => mainHTTPClient.post(
  MAIN_HTTP_API_ENDPOINTS.SERVICE_FORCE_CLOSE.replace(':id', serviceId),
  { reason }
)

const ServiceService = {
  GetServiceInfo,
  FindMany,
  ForceClose
}

export default ServiceService
